import React, { useState } from "react";
import NewOrExistingCustomHeaderAuth from "./custom_header_auth/NewOrExistingCustomHeaderAuth";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentWizardData } from "../../../../../../redux/actions/wizardActions";
import Textfield from "@atlaskit/textfield";

const OktaUrlAndAuth = () => {
  const currentData = useSelector((state) => state.wizard.currentData);
  const dispatch = useDispatch();
  const onChange = (e) => {
    const updatedData = {
      ...currentData,
      oktaBaseUrl: e.target.value,
    };
    dispatch(setCurrentWizardData(updatedData));
  };
  return (
    <>
      <br />  
      <br />
      <NewOrExistingCustomHeaderAuth info="Credentials are required to read the Okta configuration. The Okta URL is the one used to fetch data from."/>
      <br />  
      <br />
      Okta Base URL:
      <Textfield
        name="oktaBaseUrl"
        value={
          currentData?.oktaBaseUrl ? currentData?.oktaBaseUrl : ""
        }
        onChange={onChange}
      />
     Example: https://my_okta_site.okta.com
    </>
  );
};
export default OktaUrlAndAuth;
